
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
    "commitHash": "cbdd0af87e400489076259d065e2d328feb8e1b4",
    "version": "12.1.0"
};
